<script setup lang="ts">
import { reactive } from "vue";

const cancelTimelineImages = reactive({
  def: require("../../assets/stoprule_cancel_timeline.png"),
  sm: require("../../assets/stoprule_cancel_timeline_straight.png"),
});
</script>
<template>
  <div class="container py-5 fs-4">
    <section class="mb-5">
      <h2 class="mb-3">預約方法&注意事項</h2>
      <div class="precautions row row-cols-1 row-cols-xl-3 g-3">
        <div class="col">
          <div class="precautions-item bg-white rounded h-100 shadow">
            <div class="precautions-item-icon">
              <img src="../../assets/stoprule_hourglass.png" alt="hourglass" />
            </div>
            <div class="precautions-item-content">
              <p
                ><span class="hightlight">最多等待10分鐘</span
                >若遇早到、遲到請用APP或電話聯繫車隊</p
              >
            </div>
          </div>
        </div>
        <div class="col">
          <div class="precautions-item bg-white rounded h-100 shadow">
            <div class="precautions-item-icon">
              <img src="../../assets/stoprule_handup.png" alt="hourglass" />
            </div>
            <div class="precautions-item-content">
              <p>司機視以下狀況可<span class="hightlight">拒載</span>：</p>
              <ol class="fs-5">
                <li>身患法定傳染病</li>
                <li>6歲以下兒童且無陪同者</li>
                <li>精神狀況不穩定 (飲酒、吸毒)</li>
                <li>攜帶違禁品、危險品、易生變壞或破損之物品</li>
                <li>未關籠之寵物，除輔助犬</li>
              </ol>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="precautions-item bg-white rounded h-100 shadow">
            <div class="precautions-item-icon">
              <img src="../../assets/stoprule_warrning.png" alt="hourglass" />
            </div>
            <div class="precautions-item-content">
              <p>
                讓大家有車坐若要取消預約請您務必留意<span class="hightlight"
                  >取消規則</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="mb-5">
      <h2 class="mb-3">取消規則</h2>
      <div class="bg-white rounded shadow p-5 text-center">
        <div class="d-inline-block text-start" style="max-width: 530px">
          <p class="mb-5"
            >為提升派車效率、維持服務水準、避免浪費資源，愛接送訂定取消車輛的記點規則，還請大家配合！</p
          >
        </div>
        <picture>
          <source
            :srcset="cancelTimelineImages.def"
            media="(min-width: 992px)" />
          <img
            class="img-fluid"
            :src="cancelTimelineImages.sm"
            alt="計點規則說明圖" />
        </picture>
      </div>
    </section>
    <section>
      <h2 class="mb-3">停權說明</h2>
      <div class="row row-cols-1 row-cols-xl-2 g-3">
        <div class="col">
          <div class="item-style bg-white rounded shadow">
            <img
              class="img-fluid mb-4"
              src="../../assets/stoprule_stoprule_limit4point.png"
              alt="小於四點規則說明圖" />
            <div class="content text-start">
              <p>累計1~4 點，30 日內未再被登記點數，點數歸零</p>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="item-style bg-white rounded shadow">
            <img
              class="img-fluid mb-4"
              src="../../assets/stoprule_stoprule_5point.png"
              alt="大於等於五點規則說明圖" />
            <div class="content text-start">
              <p>累計至 5 點，停權使用 45 天後，點數歸零</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style lang="scss" scoped>
.precautions {
  --py: 25px;
  &-item-icon {
    text-align: center;
    padding: var(--py);
    img {
      width: 150px;
      margin: 0 auto;
    }
  }
  &-item-content {
    max-width: 370px;
    margin: 0 auto;
    padding: var(--py);
  }
}

.item-style {
  .content {
    display: inline-block;
    max-width: 370px;
  }

  text-align: center;
  padding: 25px;
}

.hightlight {
  background-color: var(--bs-danger);
  color: var(--bs-white);
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>
